import React, { useEffect } from 'react';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';
import './GoogleAuth.css';

const AuthCallback: React.FC = () => {
  const navigate = useNavigate();
  const [searchParams] = useSearchParams();
  const { login } = useAuth();

  useEffect(() => {
    const token = searchParams.get('token');
    
    if (token) {
      // Store the token and log in
      login(token);
      // Redirect to dashboard
      navigate('/dashboard');
    } else {
      // No token found, redirect to home
      navigate('/');
    }
  }, [searchParams, login, navigate]);

  return (
    <div className="google-auth-container">
      <div className="auth-loading">
        <div className="spinner"></div>
        <p>Completing sign-in...</p>
      </div>
    </div>
  );
};

export default AuthCallback;

